import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { tryToFetchActivities } from '../../../store/brokers/partner/agent-activities/agentActivitiesSlice';
import ActivitiesTable from './tables/ActivitiesTable';
import Datepicker from '../../../shared/datepicker';
import Button from '../../../shared/button';
import Input from '../../../shared/input';
import SelectCheckbox from '../../../shared/select-checkbox';
import { INVOICES_STATUS } from '../../../utils/constants/invoices-status';
import AcitivityDetailsModal from './modals/AcitivityDetailsModal';


const AgentActivities = () => {
    const dispatch = useAppDispatch();
    const [search, setSearch] = useState<string>();
    const [dateFilters, setDateFilters] = useState<any>();
    const [statusFilter, setStatusFilter] = useState<any>();
    const [rows, setRows] = useState<Array<any>>([]);
    const [showDetailsModal, setShowDetailsModal] = useState<{ show: boolean, data: any }>();
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const paginationData = useAppSelector((state) => state?.agentActivities?.agentActivities?.data?.page);
    const purchaseLoading = useAppSelector((state) => state.agentActivities.activitiesAreLoading);
    const state = useAppSelector((state) => state.agentActivities);

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10
        })
    }

    useEffect(() => {
        if (state.agentActivities) {
            const rows = state.agentActivities?.data?.elements
            setRows(rows);
        }
    }, [state.agentActivities]);

    const onGettingFilters = () => {
        let data: any = {
            agent: "accounting_agent"
        }
        if (dateFilters) {
            data = {
                ...data || {},
                ...dateFilters || {},
            }
        }
        if (statusFilter) {
            data = {
                ...data || {},
                invoiceStatus: statusFilter?.value
            }
        }
        if (search) {
            data = {
                ...data || {},
                search: search,
            }
        }
        return data ? { data: data } : {};
    }

    const onGettingData = async () => {
        try {
            const data = onGettingFilters()
            const fetchData = {
                ...paginationState || {},
                ...data || {}
            }
            await dispatch(tryToFetchActivities(fetchData)).unwrap()
        } catch (err) {
            // err
        }
    }

    useEffect(() => {
        onGettingData()
    }, [paginationState])

    const onClickClearAllFilter = () => {
        setDateFilters(undefined)
        setSearch(undefined);
        setStatusFilter(undefined)
        onResetPaginationState();
    }

    const onChangeSearchValue = (value: string | null | undefined, type: string) => {
        setSearch(value || undefined)
        onResetPaginationState()
    }

    const onChangeSelectedFilter = (e: any, type: string) => {
        setDateFilters((prevFilters: any) => ({
            ...prevFilters,
            [type]: e || undefined
        }))
        onResetPaginationState()
    }

    const onChangeSelectedStatus = (e: any, type?: string) => {
        setStatusFilter(e)
        onResetPaginationState()
    }

    const onClickShowDetailsModal = (data: any) => {
        setShowDetailsModal({
            show: true,
            data: data
        })
        document.body.style.overflow = 'hidden';
    }

    const onCloseModals = () => {
        setShowDetailsModal(undefined)
        document.body.style.overflow = 'auto';
    }

    return (
        <div>
            <div>
                <p className='page-title'>AI Agent Activities</p>
            </div>
            <div className='mb-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1 sm:gap-2 lg:gap-4'>
                <div>
                    <p className='text-primary-light font-bold text-sm mt-2 mb-2'>Invoice Status</p>
                    <SelectCheckbox
                        placeholder=' '
                        selectedOption={statusFilter}
                        options={INVOICES_STATUS}
                        onChangeSelectedOption={onChangeSelectedStatus}
                    />
                </div>
                <div className='col-span-1 lg:col-span-2'>
                    <p className='text-primary-light font-bold text-sm mt-2 mb-2'>Date Filters</p>
                    <div className='mb-6 grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-2 lg:gap-4'>
                        <Datepicker
                            placeholder='Initiated'
                            containerStyle='mb-0'
                            inputValue={dateFilters?.fromDate}
                            onChangeInput={onChangeSelectedFilter}
                            inputUniqueName={'fromDate'}
                        />
                        <Datepicker
                            placeholder='Completed'
                            containerStyle='mb-0'
                            inputValue={dateFilters?.toDate}
                            onChangeInput={onChangeSelectedFilter}
                            inputUniqueName={'toDate'}
                        />
                    </div>
                </div>
            </div>
            <div className={`flex flex-wrap justify-between items-center mt-3 bg-[#f3feed] mb-2 p-1 !rounded w-full`}>
                <div>
                    <Input
                        placeholder={'Filter Table'}
                        dataQa={'search'}
                        containerStyle='mb-0 pb-0 relative min-w-[500px]'
                        inputStyle={`mb-0 border-0 focus:outline-none`}
                        icon={'/assets/shared/search.svg'}
                        showValue={true}
                        inputValue={search}
                        inputUniqueName={'search'}
                        onChangeInput={onChangeSearchValue}
                        hideInputSpace={true}
                    />
                </div>
                <div className='flex flex-row justify-end space-x-4'>
                    <div className='flex flex-row justify-end ml-2'>
                        <Button
                            label='Clear Filters'
                            className={'btn-primary-text-underline min-w-auto'}
                            onClickButton={() => onClickClearAllFilter()}
                        />
                    </div>
                </div>
            </div>
            <ActivitiesTable
                rows={rows}
                rowsLoading={purchaseLoading}
                paginationData={paginationData}
                setPaginationState={setPaginationState}
                onSeeDetails={onClickShowDetailsModal}
            />
            {showDetailsModal?.show &&
                <AcitivityDetailsModal
                    openModal={showDetailsModal?.show}
                    data={showDetailsModal?.data}
                    handleCloseModal={onCloseModals}
                />
            }
        </div>

    )
}
export default AgentActivities;